import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from 'react-router';

import { NotificationsSnackbar } from '@/components/common/NotificationsSnackbar';
import { Sidebar, SIDEBAR_WIDTH } from '@/components/layout/Sidebar';
import { TopBar } from '@/components/layout/TopBar';
import { useUiStore } from '@/store/ui.store';

export function AppLayout() {
  const sidebarOpen = useUiStore((state) => state.sidebarOpen);

  return (
    <Box display="flex" minHeight="100vh">
      <TopBar />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          transition: (theme) =>
            theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          ml: sidebarOpen ? `${SIDEBAR_WIDTH}px` : 0,
        }}
      >
        <Toolbar />
        <Box p={3}>
          <Outlet />
        </Box>
      </Box>
      <NotificationsSnackbar />
    </Box>
  );
}
